import { Navigate, Outlet } from 'react-router';
import { REDIRECT_URL_KEY } from '@/constants/app.constant';
import appConfig from '@/configs/app.config';
import { useAuth } from '@/auth';

const { unAuthenticatedEntryPath } = appConfig;

const ProtectedRoute = () => {
  const { authenticated } = useAuth();

  const pathName = location.pathname;

  const getPathName = pathName === '/' ? '' : `?${REDIRECT_URL_KEY}=${pathName}`;

  if (!authenticated) {
    return <Navigate replace to={`${unAuthenticatedEntryPath}${getPathName}`} />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
